import React, { useState } from "react";
import "./Apply_Now.css";
import Common_Btn from "../../common/common-btn/Common_Btn";
import Solar_Modal from "../../common/solar-modal/Solar_Modal";

const Apply_Now = () => {
  const [showModal, setShowModal] = useState(false);
  return (
    <section className="Apply_Now">
      <div className="container">
        <div className="Apply_Now_div">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-6 col-sm-6">
              <div className="Apply_Now_left_div">
                <h5 className="apply_now">Apply Now for </h5>
                <h5 className="pm_surya">PM Surya Ghar: Muft Bijli Yojana</h5>
              </div>
            </div>

            <div className="col-lg-5 col-md-6 col-sm-6">
              <div className="Apply_Now_right_div">
                <p className="Apply_Now_text">
                  Get rooftop solar with government subsidy and save on your
                  electricity bills.
                </p>
                {/* <div className="apply_now_btn" onClick={() => setShowModal(true)}>
                  <Common_Btn text={"Click Here to Apply"} />
                </div> */}
                <div
                  className="apply_now_btn"
                  onClick={() =>
                    window.open("https://pmsuryaghar.gov.in/#/", "_blank")
                  }
                >
                  <Common_Btn text={"Click Here to Apply"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Solar_Modal show={showModal} handleClose={() => setShowModal(false)} />
    </section>
  );
};

export default Apply_Now;
